/* =====================================================
   Game Constants – Version 2.1 (Modified: July 31, 2025)
   Centralized game configuration values
   Date Modified: 31 July 2025 | Time: Current
===================================================== */

// Available numbers that must be used exactly once per equation
export const NUMBERS_SET = [25, 75, 2, 5, 6, 10]

// Target number players must reach with their equations
export const TARGET = 617